(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar-ad"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__adAnnInit) return;
    window.__adAnnInit = true;

    var TZ = 'America/Mexico_City';
    var FIXED = { fixed_date_dhm: 1, fixed_date_hms: 1, fixed_date_dhms: 1 };
    var WITH_DAYS = { fixed_date_dhm: 1, fixed_date_dhms: 1 };
    var DATE_RE = /^(\d{4})-(\d{1,2})-(\d{1,2})[ T](\d{1,2}):(\d{2})(?::(\d{2}))?$/;
    var isEditor = !!(window.Shopify && window.Shopify.designMode);
    var fmt = null;

    /* ---------- Zona horaria (CDMX), robusto aunque cambie de día ---------- */
    function zoneParts(ts) {
      fmt = fmt || new Intl.DateTimeFormat('en-US', {
        timeZone: TZ, hourCycle: 'h23',
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric'
      });
      var o = {};
      fmt.formatToParts(new Date(ts)).forEach(function (p) { o[p.type] = p.value; });
      return { y: +o.year, mo: +o.month, d: +o.day, h: (+o.hour) % 24, mi: +o.minute, s: +o.second };
    }
    function zoneOffset(ts) {
      var p = zoneParts(ts);
      return Date.UTC(p.y, p.mo - 1, p.d, p.h, p.mi, p.s) - (ts - (ts % 1000));
    }
    function zonedTime(y, mo, d, h, mi, s) {
      var guess = Date.UTC(y, mo - 1, d, h, mi, s);
      var off = zoneOffset(guess);
      var ts = guess - off;
      var off2 = zoneOffset(ts);
      return off2 === off ? ts : guess - off2;
    }
    function nextMidnight(now) {
      var p = zoneParts(now);
      return zonedTime(p.y, p.mo, p.d + 1, 0, 0, 0);
    }
    function parseEnd(raw) {
      var m = DATE_RE.exec(String(raw || '').trim());
      if (!m) return null;
      var mo = +m[2], d = +m[3], h = +m[4], mi = +m[5], s = +(m[6] || 0);
      if (mo < 1 || mo > 12 || d < 1 || d > 31 || h > 23 || mi > 59 || s > 59) return null;
      return zonedTime(+m[1], mo, d, h, mi, s);
    }
    function pad(n) { return n < 10 ? '0' + n : String(n); }

    /* ---------- Countdown ---------- */
    function Countdown(msg, bar) {
      this.msg = msg;
      this.bar = bar;
      this.slide = msg.closest('[data-ad-slide]');
      this.mode = msg.getAttribute('data-mode');
      this.fixed = !!FIXED[this.mode];
      this.withDays = !!WITH_DAYS[this.mode];
      this.target = this.fixed ? parseEnd(msg.getAttribute('data-end')) : null;
      this.done = false;
      this.nums = {};
      this.last = {};
      var ns = msg.querySelectorAll('[data-u]');
      for (var i = 0; i < ns.length; i++) this.nums[ns[i].getAttribute('data-u')] = ns[i];

      if (this.fixed && this.target === null) {
        // Fecha mal escrita: se oculta el countdown pero el texto del anuncio sigue visible
        this.done = true;
        msg.setAttribute('data-invalid', 'true');
        if (window.console) console.warn('[Announcement bar - AD] Fecha inválida "' + msg.getAttribute('data-end') + '". Usa YYYY-MM-DD HH:MM');
      }
    }
    Countdown.prototype.tick = function (now) {
      if (this.done) return;
      if (!this.fixed && (!this.target || now >= this.target)) this.target = nextMidnight(now);

      var diff = this.target - now;
      if (this.fixed && diff <= 0) { this.expire(); return; }

      var t = Math.max(0, Math.floor(diff / 1000));
      if (this.mode === 'fixed_date_dhm') t = Math.ceil(t / 60) * 60; // sin segundos: redondea el minuto hacia arriba

      var v = this.withDays
        ? { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600) }
        : { d: 0, h: Math.floor(t / 3600) };
      v.m = Math.floor((t % 3600) / 60);
      v.s = t % 60;

      for (var k in this.nums) {
        var s = pad(v[k]);
        if (this.last[k] !== s) { this.nums[k].textContent = s; this.last[k] = s; }
      }
    };
    Countdown.prototype.expire = function () {
      this.done = true;
      var ex = this.msg.querySelector('.ad-ann__expired');
      var hasMsg = !!(ex && ex.textContent.trim());
      var hide = this.msg.getAttribute('data-on-expire') === 'hide' || !hasMsg;

      if (hide && isEditor) {
        // En el editor no desaparece para que puedas seguir editándolo
        this.slide.setAttribute('data-editor-hidden', 'true');
        return;
      }
      this.msg.setAttribute('data-expired', 'true');
      if (hide) this.bar.removeSlide(this.slide);
      else ex.hidden = false;
    };

    /* ---------- Barra / rotador ---------- */
    function Bar(root) {
      var self = this;
      this.root = root;
      this.slides = [].slice.call(root.querySelectorAll('[data-ad-slide]'));
      this.current = this.slides[0] || null;
      this.autoplay = root.getAttribute('data-autoplay') === 'true';
      this.speed = Math.max(3, parseInt(root.getAttribute('data-speed'), 10) || 5);
      this.elapsed = 0;
      this.hover = false;
      this.focus = false;
      this.editorHold = false;
      this.lastH = null;
      this.countdowns = [];

      [].forEach.call(root.querySelectorAll('.ad-ann__msg[data-mode]'), function (m) {
        if (m.getAttribute('data-mode') !== 'none') self.countdowns.push(new Countdown(m, self));
      });

      this.bind();
      this.sync();
      this.tickCountdowns(Date.now());
    }
    Bar.prototype.bind = function () {
      var self = this, root = this.root;
      var prev = root.querySelector('[data-ad-prev]');
      var next = root.querySelector('[data-ad-next]');
      if (prev) prev.addEventListener('click', function () { self.step(-1); });
      if (next) next.addEventListener('click', function () { self.step(1); });

      root.addEventListener('mouseenter', function () { self.hover = true; });
      root.addEventListener('mouseleave', function () { self.hover = false; });
      root.addEventListener('focusin', function () { self.focus = true; });
      root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) self.focus = false; });

      var x0 = null;
      root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      root.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) self.step(dx < 0 ? 1 : -1);
      }, { passive: true });

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(function () { self.syncHeight(); });
        this.ro.observe(root);
      }
    };
    Bar.prototype.visible = function () {
      return this.slides.filter(function (s) { return !s.classList.contains('is-gone'); });
    };
    Bar.prototype.show = function (slide) {
      if (!slide) return;
      this.current = slide;
      this.elapsed = 0;
      this.slides.forEach(function (s) {
        var on = s === slide;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        var a = s.querySelector('a');
        if (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); }
      });
    };
    Bar.prototype.step = function (dir) {
      var list = this.visible();
      if (list.length < 2) return;
      var i = list.indexOf(this.current);
      this.show(list[(i + dir + list.length) % list.length]);
    };
    Bar.prototype.removeSlide = function (slide) {
      if (!slide || slide.classList.contains('is-gone')) return;
      var i = this.visible().indexOf(slide);
      slide.classList.add('is-gone');
      if (slide === this.current) {
        var rest = this.visible();
        this.show(rest[i] || rest[0]);
      }
      this.sync();
    };
    Bar.prototype.sync = function () {
      var n = this.visible().length;
      this.root.toggleAttribute('data-single', n < 2);
      this.root.hidden = n === 0;
      this.syncHeight();
    };
    // Mantiene --announcement-height igual a la altura real (el header del tema lo usa para posicionarse)
    Bar.prototype.syncHeight = function () {
      var h = this.root.hidden ? 0 : Math.ceil(this.root.getBoundingClientRect().height);
      if (h === this.lastH) return;
      this.lastH = h;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    };
    Bar.prototype.tickCountdowns = function (now) {
      for (var i = 0; i < this.countdowns.length; i++) this.countdowns[i].tick(now);
    };
    Bar.prototype.rotate = function () {
      if (!this.autoplay || this.hover || this.focus || this.editorHold) return;
      if (this.visible().length < 2) return;
      if (++this.elapsed >= this.speed) this.step(1);
    };
    Bar.prototype.needsTimer = function () {
      return this.autoplay || this.countdowns.length > 0;
    };

    /* ---------- Un solo timer global, alineado al segundo ---------- */
    var bars = [];
    var timer = null;

    function loop() {
      var now = Date.now();
      for (var i = 0; i < bars.length; i++) { bars[i].tickCountdowns(now); bars[i].rotate(); }
      schedule();
    }
    function schedule() {
      clearTimeout(timer);
      timer = null;
      if (document.hidden) return;
      if (!bars.some(function (b) { return b.needsTimer(); })) return;
      timer = setTimeout(loop, 1000 - (Date.now() % 1000) + 10);
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) {
        var now = Date.now();
        bars.forEach(function (b) { b.tickCountdowns(now); });
      }
      schedule();
    });

    function mount(root) {
      if (!root || root.__adAnn) return;
      var b = new Bar(root);
      root.__adAnn = b;
      bars.push(b);
      schedule();
    }
    function unmount(root) {
      if (!root || !root.__adAnn) return;
      var b = root.__adAnn;
      if (b.ro) b.ro.disconnect();
      bars = bars.filter(function (x) { return x !== b; });
      root.__adAnn = null;
      document.documentElement.style.removeProperty('--announcement-height');
      schedule();
    }
    function mountAll(scope) {
      [].forEach.call((scope || document).querySelectorAll('[data-ad-ann]'), mount);
    }

    /* ---------- Theme editor ---------- */
    document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      [].forEach.call(e.target.querySelectorAll('[data-ad-ann]'), unmount);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var slide = e.target.closest && e.target.closest('[data-ad-slide]');
      var root = slide && slide.closest('[data-ad-ann]');
      if (!root || !root.__adAnn) return;
      root.__adAnn.editorHold = true;
      root.__adAnn.show(slide);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target.closest && e.target.closest('[data-ad-ann]');
      if (root && root.__adAnn) root.__adAnn.editorHold = false;
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { mountAll(); });
    } else {
      mountAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["announcement-bar-dinamic-ad"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__adMqInit) return;
    window.__adMqInit = true;

    function markClone(el) {
      el.setAttribute('data-clone', '');
      el.setAttribute('aria-hidden', 'true');
      el.removeAttribute('data-ad-mq-group');
      // Los clones no deben ser "bloques" para el editor
      [el].concat([].slice.call(el.querySelectorAll('*'))).forEach(function (n) {
        n.removeAttribute('data-shopify-editor-block');
        n.removeAttribute('id');
      });
      return el;
    }

    function Marquee(root) {
      var self = this;
      this.root = root;
      this.viewport = root.querySelector('.ad-mq__viewport');
      this.track = root.querySelector('[data-ad-mq-track]');
      this.group = root.querySelector('[data-ad-mq-group]');
      this.speed = Math.max(10, parseInt(root.getAttribute('data-speed'), 10) || 60);
      this.originals = [].slice.call(this.group.children);
      this.lastW = 0;
      this.lastH = null;
      this.editorHold = false;
      this.raf = null;

      this.onResize = function () { self.queue(); };

      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.onResize);
        this.ro.observe(root);
      } else {
        window.addEventListener('resize', this.onResize);
      }

      // Re-medir cuando carguen íconos o fuentes (cambian el ancho real)
      [].forEach.call(root.querySelectorAll('img'), function (img) {
        if (!img.complete) img.addEventListener('load', function () { self.rebuild(); }, { once: true });
      });
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(function () { self.rebuild(); });
      }

      this.build();
    }

    Marquee.prototype.queue = function () {
      var self = this;
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(function () { self.raf = null; self.build(); });
    };

    Marquee.prototype.rebuild = function () {
      this.lastW = 0;
      this.queue();
    };

    Marquee.prototype.build = function () {
      this.syncHeight();
      var w = this.viewport.clientWidth;
      if (!w || w === this.lastW) return;
      this.lastW = w;

      var group = this.group;
      [].forEach.call(this.track.querySelectorAll('[data-clone]'), function (n) { n.remove(); });
      this.root.classList.remove('is-ready');
      if (!this.originals.length) return;

      // 1) Repetir los anuncios dentro del grupo hasta que cubra todo el ancho visible
      var guard = 0;
      while (group.getBoundingClientRect().width < w && guard++ < 40) {
        this.originals.forEach(function (n) { group.appendChild(markClone(n.cloneNode(true))); });
      }

      // 2) Duplicar el grupo completo para que el loop sea continuo
      this.track.appendChild(markClone(group.cloneNode(true)));

      // 3) Duración según el ancho real, así la velocidad (px/s) es constante con 2 o 10 anuncios
      var gw = group.getBoundingClientRect().width;
      this.track.style.setProperty('--ad-mq-dur', (gw / this.speed).toFixed(2) + 's');
      this.root.classList.add('is-ready');
    };

    Marquee.prototype.syncPaused = function () {
      this.root.classList.toggle('is-paused', this.editorHold);
    };

    // Mantiene --announcement-height igual a la altura real (el header del tema lo usa para posicionarse)
    Marquee.prototype.syncHeight = function () {
      var h = this.root.hidden ? 0 : Math.ceil(this.root.getBoundingClientRect().height);
      if (h === this.lastH) return;
      this.lastH = h;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    };

    Marquee.prototype.destroy = function () {
      if (this.ro) this.ro.disconnect();
      else window.removeEventListener('resize', this.onResize);
      if (this.raf) cancelAnimationFrame(this.raf);
    };

    function mount(root) {
      if (!root || root.__adMq) return;
      root.__adMq = new Marquee(root);
    }
    function unmount(root) {
      if (!root || !root.__adMq) return;
      root.__adMq.destroy();
      root.__adMq = null;
      document.documentElement.style.removeProperty('--announcement-height');
    }
    function mountAll(scope) {
      [].forEach.call((scope || document).querySelectorAll('[data-ad-mq]'), mount);
    }

    /* ---------- Theme editor ---------- */
    document.addEventListener('shopify:section:load', function (e) { mountAll(e.target); });
    document.addEventListener('shopify:section:unload', function (e) {
      [].forEach.call(e.target.querySelectorAll('[data-ad-mq]'), unmount);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var item = e.target.closest && e.target.closest('.ad-mq__item');
      var root = item && item.closest('[data-ad-mq]');
      if (!root || !root.__adMq) return;
      item.setAttribute('data-editor-selected', '');
      root.__adMq.editorHold = true;
      root.__adMq.syncPaused();
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var item = e.target.closest && e.target.closest('.ad-mq__item');
      var root = item && item.closest('[data-ad-mq]');
      if (item) item.removeAttribute('data-editor-selected');
      if (!root || !root.__adMq) return;
      root.__adMq.editorHold = false;
      root.__adMq.syncPaused();
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { mountAll(); });
    } else {
      mountAll();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.handleDocumentClick = this.handleDocumentClick.bind(this);
      this.elements.button.addEventListener('click', this.togglePanel.bind(this));
      this.addEventListener('keydown', this.onEscapePress.bind(this));

      this.querySelectorAll('a').forEach((item) => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    connectedCallback() {
      document.addEventListener('click', this.handleDocumentClick);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    showPanel() {
      this.elements.button.setAttribute('aria-expanded', 'true');
      this.elements.panel.removeAttribute('hidden');
    }

    togglePanel() {
      if (this.elements.button.getAttribute('aria-expanded') === 'true') {
        this.hidePanel();
      } else {
        this.showPanel();
      }
    }

    onEscapePress(event) {
      if (event.key === 'Escape') {
        this.hidePanel();
      }
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form')?.submit();
      this.hidePanel();
    }
  }

  if (!customElements.get('localization-form')) {
    customElements.define('localization-form', LocalizationForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerWrapper = document.querySelector('.header-wrapper');
      this.headerInner = document.querySelector('.header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();

      if (this.headerIsAlwaysSticky) this.reveal;
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
        this.header.classList.add('shopify-section-header-sticky', 'shopify-section-header-always-sticky');
        this.header.style.transform = 'translateY(-100%)';
      }

      if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
        this.header.style.transition = 'background var(--duration-short), transform var(--duration-default)';
        this.header.style.transform = 'translateY(0)';
      }

      if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
        this.header.classList.remove('shopify-section-header-sticky');
        this.header.style.transform = 'translateY(0)';
        this.header.style.transition = 'background var(--duration-short)';
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
    }

    reveal() {
      //if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      if (this.disclosures) {
        this.disclosures.forEach((disclosure) => {
          disclosure.close();
        });
      }
      this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
      if (this.disclosureLists) {
        this.disclosureLists.forEach((disclosureList) => {
          disclosureList.setAttribute('hidden', true);
        });
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener(
        'change',
        debounce((event) => {
          const body = JSON.stringify({ note: event.target.value });
          fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        }, 300)
      );
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);

      if (
        activeMedia.nodeName == 'DEFERRED-MEDIA' &&
        activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
      )
        activeMedia.loadContent();
    }
  }
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations--single');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 200px 0px' }).observe(this);
    }
  }

  customElements.define('product-modal', ProductModal);
  customElements.define('product-recommendations--single', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initPromoCards(section) {
      if (!section || section.dataset.promoInit === 'true') return;
      section.dataset.promoInit = 'true';

      var swiperEl = section.querySelector('.promo-cards__swiper');
      if (!swiperEl) return;

      var prevBtn = section.querySelector('.promo-cards__btn--prev');
      var nextBtn = section.querySelector('.promo-cards__btn--next');

      var autoplay = section.dataset.autoplay === 'true';
      var stopAutoplay = section.dataset.stopAutoplay === 'true';
      var speed = parseFloat(section.dataset.speed) * 1000 || 600;
      var delay = parseFloat(section.dataset.delay) * 1000 || 4000;

      var slidesCount = swiperEl.querySelectorAll('.swiper-slide').length;

      function build() {
        if (typeof window.Swiper === 'undefined') return;

        var config = {
          slidesPerView: 1.15,
          spaceBetween: 16,
          speed: speed,
          watchOverflow: true,
          breakpoints: {
            550: { slidesPerView: 2.15, spaceBetween: 16 },
            768: { slidesPerView: 3, spaceBetween: 20 },
            1024: { slidesPerView: 4, spaceBetween: 20 },
            1280: { slidesPerView: Math.min(5, slidesCount), spaceBetween: 24 }
          },
          navigation: (prevBtn && nextBtn) ? {
            prevEl: prevBtn,
            nextEl: nextBtn,
            disabledClass: 'swiper-button-disabled'
          } : false
        };

        if (autoplay && slidesCount > 1) {
          config.autoplay = {
            delay: delay,
            disableOnInteraction: false,
            pauseOnMouseEnter: stopAutoplay
          };
        }

        new window.Swiper(swiperEl, config);
      }

      if (typeof window.Swiper !== 'undefined') {
        build();
      } else {
        var interval = setInterval(function () {
          if (typeof window.Swiper !== 'undefined') {
            clearInterval(interval);
            build();
          }
        }, 100);
        setTimeout(function () { clearInterval(interval); }, 5000);
      }
    }

    function initAll() {
      document.querySelectorAll('.promo-cards').forEach(initPromoCards);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.promo-cards');
      if (section) initPromoCards(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
